import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  Renderer2, ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'mcrai-media',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
})
export class MediaComponent implements OnInit {
  protected _width: number | string;
  protected _height: number | string;
  protected _src: string;

  @Input() set width(value: number | string) {
    this._width = value;
  }

  @Input() set height(value: number | string) {
    this._height = value;
  }

  get src(): string {
    return this._src;
  }

  public closeEvent: Subject<null> = new Subject<null>();

  constructor(
    protected _elRef: ElementRef,
    protected _changeDetectorRef: ChangeDetectorRef,
    protected _renderer: Renderer2,
    protected _ngZone: NgZone
  ) { }

  ngOnInit() { }

  protected toString(dimension: string | number | null): string {
    if (!dimension) {
      return 'auto';
    }

    if (typeof dimension === 'number') {
      return dimension + 'px';
    }

    return dimension.slice(-1) === '%' ? dimension : dimension + 'px';
  }

  protected toNumber(dimension: string | number, parent: number): number {
    if (typeof dimension === 'number') {
      return dimension;
    }

    if (dimension.slice(-1) === '%') {
      return parent * parseInt(dimension, 10) / 100;
    }

    return parseInt(dimension, 10);
  }

  public close(): void {
    this.closeEvent.next();
  }
}
